import banner from './aboutUs/banner.webp';
import monitoring from './aboutUs/monitoring.png';
import online_lesson from './aboutUs/online-lesson.png';
import reading_books from './aboutUs/reading-book.png';
import virtual_class from './aboutUs/virtual-class.png';
import home from './home.webp';
import contactUs from './contactUs/contactUs.webp';
import email from './contactUs/email.webp';
import location from './contactUs/location.webp';
import phone from './contactUs/phone.webp';
import instituteSignup from './signup/institute.webp';
import parentSignup from "./signup/parent.webp";
import studentSignup from "./signup/student.webp";
import teacherSignup from "./signup/teacher.webp";
import bannerSignup from './signup/banner.webp';
import logo from "./logo.png";
import formComplete from "./signup/formComplete.png"
import unAuth from "./auth/401.webp";
import notFound from "./auth/404.webp";
import parentpro from "./profile/mr1.jpg"
import stundetreg from "./profile/st1.jpg"
import tutorpro from "./profile/mr2.jpg"
import instpro from "./profile/inst1.png"
import download from "./aboutUs/download.png"
import linux from "./aboutUs/linux.png"
import windows from "./aboutUs/windows.png"
import chart from "./chart.png"
export default {
    download,
    chart,
    linux,
    windows,
    instpro,
    tutorpro,
    stundetreg,
    parentpro,
    banner,
    monitoring,
    online_lesson,
    reading_books,
    virtual_class,
    home,
    contactUs,
    email,
    location,
    phone,
    instituteSignup,
    parentSignup,
    studentSignup,
    teacherSignup,
    bannerSignup,
    logo,
    formComplete,
    unAuth,
    notFound
}